// DB 행(ContractRow/ContractSale) ↔ 마진 모델(Contract/SaleRow) 브리지.
// 이식된 마진 UI·집계 함수(contractProgress/contractPace/QuotaTrack…)는 모델
// 타입을 그대로 받으므로, DB 행을 읽기 전용 모델로 변환해 재사용한다 (Design §3).
import type { ContractRow, ContractSale } from "@/types";
import type { Contract, SaleRow } from "@/lib/margin/model";
import { emptyFree } from "@/lib/margin/model";

export function contractRowToModel(row: ContractRow): Contract {
  return {
    id: row.id,
    name: row.name,
    country: row.country_name ?? row.destination_country,
    buyer: row.buyer_name ?? "",
    startDate: row.start_date ?? "",
    endDate: row.end_date ?? "",
    demoStart: row.demo_start ?? "",
    demoEnd: row.demo_end ?? "",
    demoQty: row.demo_qty ?? 0,
    licenseLabel: row.license_label ?? "",
    licenseStart: row.license_start ?? "",
    licenseEnd: row.license_end ?? "",
    licenseDone: row.license_done ?? false,
    quotaStart: row.quota_start ?? "",
    tiers: Array.isArray(row.tiers)
      ? row.tiers.map((t) => ({ fromQty: t.fromQty, toQty: t.toQty ?? null, price: t.price, freeUnits: t.freeUnits ?? 0 }))
      : [],
    free: row.free ? { ...emptyFree(), ...row.free } : emptyFree(),
    targetQty: row.target_qty,
    note: row.note ?? "",
  };
}

export function saleToModel(s: ContractSale): SaleRow {
  return {
    id: s.id,
    date: s.sale_date,
    country: "",
    buyer: s.buyer ?? "",
    qty: Number(s.qty) || 0,
    priceUsd: Number(s.price_usd) || 0,
    fx: Number(s.fx) || 0,
    costKrw: Number(s.cost_krw) || 0,
    commKrw: Number(s.comm_krw) || 0,
    extraKrw: Number(s.extra_krw) || 0,
    contractId: s.contract_id,
    note: s.note ?? "",
  };
}
